import { CommonModule } from "@angular/common";
import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
} from "@angular/core";

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: "app-order-cursor",
  styles: [
    `
      :host {
        display: block;
        width: 100%;
        height: 2px;
        margin-top: -3px;
        position: absolute;
        z-index: 100;
        padding-top: 3px;
        padding-bottom: 3px;
      }

      :host:hover {
        background-color: rgb(138, 230, 193);
      }

      :host.active {
        background-color: transparent;
      }

      hr {
        height: 3px;
        color: #1acb83;
        background: #1acb83;
        font-size: 0;
        border: 0;
        padding: 0;
        margin: 0;
        margin-top: -2px;
      }
    `,
  ],
  template: ` <hr *ngIf="active" /> `,
})
export class OrderCursorComponent implements OnInit {
  @Output() click = new EventEmitter<any>();

  @HostBinding("class.active") @Input() active = true;

  constructor() {}

  ngOnInit(): void {}

  clicked() {
    this.click.emit("");
  }
}
